import { API_URL } from '../../../../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
    showErrorMessage
} from './../../../../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    showErrorMessage,
    extractDataFromObject, 
    API_URL,
};

export const GET_PROGRAM_LIST_API = `${API_URL}/api/MasterPrograms/GetMasterPrograms`;
export const POST_PROGRAM_API = `${API_URL}/api/MasterPrograms/SaveMasterProgram`;
export const GET_PROGRAM_DETAILS_API = `${API_URL}/api/MasterPrograms/GetMasterProgramById`;
export const GET_PROGRAM_DETAILS_BY_DOMAIN_API = `${API_URL}/api/MasterPrograms/GetMasterProgramsByDomainId`;
export const DELETE_PROGRAM_API = `${API_URL}/api/MasterPrograms/DeleteMasterProgram`;
export const PROGRAM_STATUS_ACTIVATION = `${API_URL}/api/MasterPrograms/UpdateProgramActiveStatus`;

export const ProgramActionTypes = {
  get_programList: createRequestActionTypes('GET_PROGRAMLIST'),
  post_program: createRequestActionTypes('POST_PROGRAM'),
  get_programDetails: createRequestActionTypes('GET_PROGRAMDETAILS'),
  get_programDetailsByDomain: createRequestActionTypes('GET_PROGRAMDETAILSBYDOMAIN'),
  delete_program: createRequestActionTypes('DELETE_PROGRAM'),
  program_active_status: createRequestActionTypes('PROGRAM_ACTIVE_STATUS'),
};

export const MODULE = 'DCMASTER_PROGRAMS';





// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/program/constants/ApiConstants.js